import axios from "axios";
import { getAuthToken } from "./authService";

const API_URL = process.env.REACT_APP_AUTH_SERVICE_URL;

const getHeaders = () => {
  const token = getAuthToken();
  if (!token) throw new Error("No active session");
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`
  };
};

export const generateApiToken = async (tokenName, expirationDays) => {
  try {
    const payload = { tokenName, expirationDays };
    const response = await axios.post(`${API_URL}/generate-api-token`, payload, { headers: getHeaders() });
    return response.data.token;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to generate API token");
  }
};

export const fetchApiTokens = async () => {
  try {
    const response = await axios.get(`${API_URL}/api-tokens`, { headers: getHeaders() });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch API tokens");
  }
};

export const deleteApiToken = async (tokenId) => {
  try {
    const response = await axios.delete(`${API_URL}/api-tokens/${tokenId}`, { headers: getHeaders() });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to delete API token");
  }
};
